class materialsService {
    constructor($http) {
        'ngInject';

        this.$http = $http;
    }

    getMaterials() {
        return this.$http.get(
                `/admpanel/ajax/configurator/getMaterials`
                );
    }

    getPriceGroups() {
        return this.$http.get(
                `/admpanel/ajax/configurator/getPriceGroups`
                );
    }

    getLanguages() {
        return this.$http.get(
                `/admpanel/ajax/settings/getLanguages`
                );
    }

    getShops() {
        return this.$http.get(
                `/admpanel/ajax/settings/getShops`
                );
    }

    cleanModel(model, level) {
        for (const item of model) {
            if (item.items.length > 0) {
                item.childPrices = null;
                item.childCutPrices = null;
                item.value = null;
                this.cleanModel(item.items, level + 1);
            } else {
                item.prices = null;
                item.cutPrices = null;
            }
        }

        return model;
    }

    saveMaterials(model) {
        const cleanModel = this.cleanModel(model, 0);

        return this.$http.post(
                `/admpanel/ajax/configurator/saveMaterials`,
                model
                );
    }
}

export default materialsService;